import { Phone, Mail, MapPin, Download } from "lucide-react";
import { Logo } from "@/components/Logo";
import { scrollToId } from "@/lib/scroll";
import { agreementDownloadUrl } from "@/lib/api";

export const Footer = ({ settings }) => {
  const phone = settings?.phone || "(555) 210-4400";
  const email = settings?.email || "quotes@fleetguardinsurance.com";
  const address = settings?.address || "1420 Freight Lane, Suite 300, Dallas, TX 75207";
  const claims = settings?.claims_line || "1-800-555-0187";

  const links = [
    { id: "about", label: "About Us" },
    { id: "coverage", label: "Coverage Types" },
    { id: "savings", label: "50% Savings" },
    { id: "testimonials", label: "Testimonials" },
    { id: "faq", label: "FAQ" },
  ];

  return (
    <footer className="bg-[#0B1120] pb-8 pt-16 text-white" data-testid="footer">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid gap-12 border-b border-white/10 pb-12 md:grid-cols-2 lg:grid-cols-4">
          <div>
            <Logo light />
            <p className="mt-5 max-w-xs text-sm leading-relaxed text-white/55">
              America's trusted commercial trucking &amp; fleet coverage — fast filings, live claims,
              and honest pricing.
            </p>
            <div className="mt-5 inline-flex items-center gap-2 rounded-full bg-brand-orange/15 px-4 py-2 text-xs font-semibold text-brand-orange">
              <Phone className="h-3.5 w-3.5" /> 24/7 Claims: {claims}
            </div>
          </div>

          <div>
            <h4 className="font-mono text-[11px] uppercase tracking-[0.3em] text-white/40">Contact</h4>
            <ul className="mt-5 space-y-4 text-sm text-white/70">
              <li className="flex items-start gap-3" data-testid="footer-phone">
                <Phone className="mt-0.5 h-4 w-4 shrink-0 text-brand-blue" /> {phone}
              </li>
              <li className="flex items-start gap-3" data-testid="footer-email">
                <Mail className="mt-0.5 h-4 w-4 shrink-0 text-brand-blue" /> {email}
              </li>
              <li className="flex items-start gap-3" data-testid="footer-address">
                <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-brand-blue" /> {address}
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-mono text-[11px] uppercase tracking-[0.3em] text-white/40">Company</h4>
            <ul className="mt-5 space-y-3 text-sm text-white/70">
              {links.map((l) => (
                <li key={l.id}>
                  <button
                    data-testid={`footer-link-${l.id}`}
                    onClick={() => scrollToId(l.id)}
                    className="transition-colors hover:text-white"
                  >
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-mono text-[11px] uppercase tracking-[0.3em] text-white/40">Clients</h4>
            <ul className="mt-5 space-y-3 text-sm text-white/70">
              <li>
                <a
                  href={agreementDownloadUrl}
                  data-testid="footer-download-agreement"
                  className="inline-flex items-center gap-2 transition-colors hover:text-white"
                >
                  <Download className="h-4 w-4 text-brand-blue" /> Client Agreement (PDF)
                </a>
              </li>
              <li>
                <a href="/download" data-testid="footer-download-setup" className="transition-colors hover:text-white">
                  Download Setup
                </a>
              </li>
              <li>
                <button data-testid="footer-become-client" onClick={() => scrollToId("become-client")} className="transition-colors hover:text-white">
                  Become a Client
                </button>
              </li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col items-center justify-between gap-3 pt-8 text-xs text-white/40 sm:flex-row">
          <p>© 2026 Fleetguard Insurance. All rights reserved.</p>
          <p className="font-mono uppercase tracking-[0.2em]">Licensed in all 50 states · FMCSA compliant</p>
        </div>
      </div>
    </footer>
  );
};
